<app-header></app-header>

<div class="container mt-2 pt-5">
    <div class="row align-items-center">
    
    	<!--<div class="col-md-6 pr-0 order-md-1">
            <img src="img/partner.jpg" class="img-fluid">            
        </div>-->
    	
    	<div class="col-md-12 feature-txt py-4">
            <h2 class="h2">{{pocDetail.title}}</h2>
            <!--<p class="text-justify">OMNI is the world's first and only aggregator of RPA platforms – get your business users to try and test any platform of their choice, build the automation workflows of their choice and
save time and increase their productivity.</p>-->
        </div>
        
        
    </div>
</div>

<section *ngIf="pocDetail != null" class="container-fluid py-5 bg-grey">
	<div class="container">
      
      <div class="body-content row">
          <div class="col bg-white border p-5">
          	<div class="row mb-4">
            	<div class="col">
                	<div class="quick-filter">
                    	<a class="text-orange mr-3">Overview</a>
                        <a (click)="onClick(poc_detail)" class="text-orange mr-3">Details</a>
                        <a (click)="onClick(poc_requirement)" class="text-orange">System Requirement</a>
                    </div>
                </div>
            </div>
          	<div id="poc-overview" class="row">
            	<div class="col-md-12"><p class="h3">Overview</p></div>
            	<div class="col-md-7">
                	
                     <p class="content font-small">{{pocDetail.info}}</p>
                </div>
                
                <div class="col-md-5">
                	<p class="h5">Available for: </p>
                	<p *ngFor="let tool of pocDetail.toolsDetail" class="d-flex align-items-center"><span class="image-icon small-icon d-inline-block mr-2"><img [src]="tool.platformImage"></span><span class="mr-3">{{tool.platformName}}</span></p>                    
                </div>
            </div>
            
            <div class="row mt-3">
            	<div class="col-md-6 ">
                	<div class="poc-benefit">
                    	<p class="h5">Top Benefits</p>
                        <p>At the end of this course you should be able to:</p>
                        <ul>
                        	<li *ngFor="let benefit of pocDetail.benefits">{{benefit}}</li>
                            
                        </ul>
                    </div>
                </div>
                
                <div class="col-md-6">
                	<video width="100%" height="auto" controls="" >
                        <source *ngIf="videoUrl" [src]="videoUrl" type="video/mp4" />
                      <!--<source src="movie.ogg" type="video/ogg">-->
                    Your browser does not support the video tag.
                    </video>
                    
                    
                </div>
            </div>
            


            <div #poc_detail id="poc-detail" class="row mt-5">
                <div class="col-md-12">
                  <p class="h3 mb-3">Details</p>
                </div>
      
                <div class="col-md-6">
                  <div class="row explore-poc-details">
                    <div class="col font-small">
      
                      <div class="row">
                        <div class="col-4">Bot Compexity:</div>
                        <div *ngIf="pocDetail && pocDetail.complexity" class="col-8">
                          <strong>{{pocDetail.complexity.toUpperCase()}}</strong></div>
                      </div>
      
                      <div class="row">
                        <div class="col-4">Business Function:</div>
                        <div *ngIf="pocDetail" class="col-8"><strong>{{pocDetail.business}}</strong></div>
                      </div>
                      <div class="row">
                        <div class="col-4">Industry: </div>
                        <div *ngIf="pocDetail" class="col-8"><strong>{{pocDetail.industry}}</strong></div>
                      </div>
      
                    </div>
      
                  </div>
                </div>
      
                <div class="col-md-6">
                  <div class="row explore-poc-details">
                    <div class="col font-small">
                      <div class="row">
                        <div class="col-4">Technology:</div>
                        <div *ngIf="pocDetail && pocDetail.technology" class="col-8">
                          <strong>{{pocDetail.technology.toString().replaceAll(",","/")}}</strong></div>
                        <!-- <label class="pill-box-inside" *ngFor="let item of pocDetail.technology">{{item}}</label> -->
                      </div>
                      <div class="row">
                        <div class="col-4">Last Updated:</div>
                        <div *ngIf="pocDetail && pocDetail.updatedOn" class="col-8"><strong>{{pocDetail.updatedOn |
                            date:'MMM d, y'}}</strong></div>
                      </div>
                      <div class="row">
                        <div class="col-4">First Published:</div>
                        <div *ngIf="pocDetail && pocDetail.publishedOn" class="col-8"><strong>{{pocDetail.publishedOn |
                            date:'MMM d, y'}}</strong></div>
                      </div>
      
                    </div>
      
                  </div>
                </div>
              </div>
      
              <div #poc_requirement id="poc_requirement" class="row mt-5">
                <div class="col-md-12">
                  <p class="h3 mb-3">System Requirement</p>
                </div>
      
                <div *ngFor="let sysReq of pocDetail.systemRequirements" class="col-md-6">
                  <div class="row explore-poc-details">
                    <div class="col font-small">
      
                      <div class="row">
                        <div class="col-4">{{sysReq.name}}:</div>
                        <div class="col-8"><strong>{{sysReq.value}}</strong></div>
                      </div>
                    </div>
      
                  </div>
                </div>
      
                
              </div>


          </div>
       </div>
       
       
       
       
	</div>
</section>


<app-footer></app-footer>